import styled from 'styled-components';

export const StyledSliderContainer = styled.div`
  position: relative;
  width: 100%;
`;
